import React from "react";

export const ContentViewportContext = React.createContext<HTMLElement | null>(
  null,
);
